import type { SupabaseClient } from '@supabase/supabase-js';

export type PhotoRow = { id: string; storage_path: string; thumb_path: string | null; exercise_key: string | null; set_id: string | null; created_at: string };

/** Photos for a session with short-lived signed URLs (thumbnail when available). */
export async function listPhotos(client: SupabaseClient, sessionId: string): Promise<Array<PhotoRow & { url: string | null }>> {
  const { data, error } = await client.from('photos').select('*').eq('session_id', sessionId).order('created_at');
  if (error) throw error;
  const rows = data as PhotoRow[];
  if (!rows.length) return [];
  const paths = rows.map((r) => r.thumb_path ?? r.storage_path);
  const signed = await client.storage.from('photos').createSignedUrls(paths, 3600);
  return rows.map((r, i) => ({ ...r, url: signed.data?.[i]?.signedUrl ?? null }));
}
